import moment from 'moment';
import * as partHelpers from '@/common/partHelpers';
import PartAlertLevel from '@/common/PartAlertLevel';
import sanitizeHtml from 'sanitize-html';
import log from '@/logger';

export const flattenParts = function (parent) {
  var flat = [];

  if (parent.children) {
    for (var child of parent.children) {
      if (child.children) {
        flat = flat.concat(flattenParts(child));
      } else {
        flat.push(child);
      }
    }
  } else {
    log.warn('Non parent as parent', JSON.stringify(parent, null, '\t'));
  }

  return flat;
};

export const filterParts = function (
  state,
  parent,
  filterText,
  filterDate,
  filterDateEnd,
  filter,
  level,
  parentManagerId,
  breadCrumbs,
  occupation,
  filterTextRs
) {
  if (!level) {
    console.debug(
      'filterparts',
      filterText,
      filterDate,
      filterDateEnd,
      filter,
      level,
      parentManagerId,
      breadCrumbs,
      occupation
    );
  }

  if (filterText && !filterTextRs) {
    filterText = filterText
      .toLowerCase()
      .trim()
      .match(/(?:[^\s"]+|"[^"]*")+/g)
      .join('|')
      .replace(/"([^"]+)"/g, '(^|[^0-9a-z-])$1($|[^0-9a-z-])');
    filterTextRs = new RegExp(filterText);
  }

  if (!parent || !parent.children) {
    return parent;
  }
  if (!parentManagerId) {
    parentManagerId = state.currentProject.developingManagerId;
  }
  var filtered = [];
  var starttime;
  var alert = PartAlertLevel.Ok;
  breadCrumbs = breadCrumbs || [];
  if (!level) {
    level = 0;
    starttime = moment();
  }

  for (var child of parent.children) {
    if (child.children) {
      var realStage = state.stages[child._id];
      if (!realStage) {
        log.warn('Stumbled on non existing stageId', [child._id]);
        continue;
      }

      if (filter && filter.excludeLockedDiaries && realStage.lockedDiary) {
        continue;
      }

      if (filterText.length > 0) {
        if (realStage.title && filterTextRs.test(realStage.title.toLowerCase())) {
          var unfilteredchildrenBreadCrumbs = breadCrumbs.slice();
          unfilteredchildrenBreadCrumbs.push(realStage.title);
          var unfilteredChildren = filterParts(
            state,
            child,
            '',
            '',
            '',
            '',
            level + 1,
            realStage.stageManagerId || parentManagerId,
            unfilteredchildrenBreadCrumbs,
            realStage.stageOccupation || occupation,
            filterTextRs
          );
          alert = PartAlertLevel.mostSevere(alert, unfilteredChildren.alert);
          filtered.push(Object.assign({}, child, unfilteredChildren, { breadCrumbs: breadCrumbs }));
          continue;
        }
      }
      if (child.children.length === 0) {
        if (filterText === '') {
          filtered.push(Object.assign({}, child, { breadCrumbs: breadCrumbs, alert: alert }));
        }
        continue;
      }
      var childrenBreadCrumbs = breadCrumbs.slice();
      childrenBreadCrumbs.push(realStage.title);
      var newChild = filterParts(
        state,
        child,
        filterText,
        filterDate,
        filterDateEnd,
        filter,
        level + 1,
        realStage.stageManagerId || parentManagerId,
        childrenBreadCrumbs,
        realStage.stageOccupation || occupation,
        filterTextRs
      );
      if (newChild && newChild.children.length > 0) {
        alert = PartAlertLevel.mostSevere(alert, newChild.alert);
        filtered.push(Object.assign({}, child, newChild, { breadCrumbs: breadCrumbs }));
        continue;
      }
    } else {
      var realPart = state.parts[child._id];
      if (!realPart) {
        log.warn('filterParts: did not find real part', [child._id]);
        continue;
      }

      if (filterDate !== '') {
        if (
          !(
            (realPart.startdate > filterDate ? realPart.startdate : filterDate) <=
            (realPart.expectedDonedate < filterDateEnd ? realPart.expectedDonedate : filterDateEnd)
          )
        ) {
          continue;
        }
      }

      if (filterText.length > 0) {
        if (realPart.title && !filterTextRs.test(realPart.title.toLowerCase())) {
          continue;
        }
      }

      if (filter && filter.partManagerId) {
        let projectRole = '';
        let o = realPart.partOccupation || occupation;
        if (o) {
          for (let i = 0; i < state.currentProject.projectManagers.length; i++) {
            if (state.currentProject.projectManagers[i].occupation === o) {
              projectRole = state.currentProject.projectManagers[i].personId;
              i = 999;
            }
          }
          if (!projectRole) {
            for (let i = 0; i < state.currentProject.projectSubcontractors.length; i++) {
              if (state.currentProject.projectSubcontractors[i].occupation === o) {
                projectRole = state.currentProject.projectSubcontractors[i].personId;
                i = 999;
              }
            }
          }
        }
        if (
          !(
            (realPart.partManagerId && filter.partManagerId === realPart.partManagerId) ||
            (!realPart.partManagerId && filter.partManagerId === parentManagerId) ||
            (realPart.partSubcontractorId && filter.partManagerId === realPart.partSubcontractorId) ||
            (!realPart.partSubcontractorId && filter.partManagerId === projectRole)
          )
        ) {
          continue;
        }
      }

      if (filter && filter.filterDeliveries) {
        if (realPart.deliverydate === '' || realPart.deliverydate === '0000-01-01') {
          continue;
        }
      }

      var partAlert = partHelpers.partAlert(realPart);
      if (filter && filter.filterAlerts) {
        if (partAlert === PartAlertLevel.Ok) {
          continue;
        }
      }

      if (filter && filter.filterLate) {
        if (!partHelpers.isLate(realPart) && !partHelpers.isPostPoned(realPart)) {
          continue;
        }
      }

      if (filter && filter.filterLateDeliveries) {
        if (!partHelpers.isLateDelivery(realPart)) {
          continue;
        }
      }

      var lateTime = '';
      var reason = partHelpers.partAlertReason(realPart);
      if (reason) {
        lateTime = realPart[reason];
      }

      alert = PartAlertLevel.mostSevere(alert, partAlert);
      filtered.push({
        type: 'Part',
        _id: realPart._id,
        title: realPart.title,
        lateTime,
        part: realPart,
        alert: partAlert,
        breadCrumbs: breadCrumbs,
        occupation: realPart.partOccupation || occupation,
      });
    }
  }
  if (level === 0) {
    console.debug('filterparts done', [moment().diff(starttime, 'ms')]);
  }

  return Object.assign({}, parent, { children: filtered, alert: alert });
};

export const extractMentions = function (text) {
  var regex = new RegExp('<span[^>]*data-id="([^"]+)"[^>]*>([^<]+)</span>', 'gi');
  var mentions = [];
  var match;
  while ((match = regex.exec(text)) !== null) {
    if (!mentions.includes(match[1])) {
      mentions.push(match[1]);
    }
  }
  text = sanitizeHtml(text, {
    nonTextTags: ['style', 'script', 'textarea', 'noscript', 'span'],
  });
  // text = text.replace('@', '').trim();
  text = text.trim();
  return { text, mentions };
};

export const setMention = function (text, person) {
  text = sanitizeHtml(text, {
    nonTextTags: ['style', 'script', 'textarea', 'noscript', 'span'],
  });
  if (person) {
    text =
      '<span contenteditable="false"> <span class="tag" data-id="' +
      person._id +
      '">' +
      person.firstName +
      ' ' +
      person.lastName +
      '</span> </span> ' +
      text.trim();
  } else {
    text = text.trim();
  }
  return text;
};



// WEBPACK FOOTER //
// ./src/common/filters.js